const awsmobile = {
};

export default awsmobile;
